import { NgModule } from '@angular/core';

import { GenericModule } from '../generic';
import { QueuingSystemSharedModule } from '../../shared';

import { LoginComponent } from './login.component';
import { LoginModalService } from './login-modal.service';

@NgModule({
    imports: [
        QueuingSystemSharedModule,
        GenericModule
    ],
    declarations: [
        LoginComponent
    ],
    providers: [
        LoginModalService
    ],
    entryComponents: [
        LoginComponent
    ],
    exports: [
        LoginComponent
    ]
})
export class LoginModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/login/login.module.ts